import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import DatePicker from "react-multi-date-picker";
import { numberSuffix } from '../../helper/stringMethods';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { addDay } from '../../helper/dateHelper';
import { makeApiCall } from '../../services/httpService';
import { BASE_URL } from '../../config';
import toast from 'react-hot-toast';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import DContext from '../../context/DContext';
import { roundTo2Digits } from '../../helper/commonHelper';
import ContentLoader from '../loader/ContentLoader';


const AddInventory = () => {
  const location = useLocation();

  const { authState, authDispatch, logout } = useContext(DContext);
  const { user, userProfile } = authState;

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1)
  const [monthsToShow, setMonthsToShow] = useState(window.innerWidth < 768 ? 1 : 2);
  const [dateValue, setDateValue] = useState([]); // if we want to preselect some date put in this array
  const [nextDayArrivalSelectedValue, setNextDayArrivalSelectedValue] = useState("0");
  const [flightStops, setFlightStops] = useState(0);
  const [airlinesDropdown, setAirlinesDropdown] = useState([]);
  const [stopsData, setStopsData] = useState([]);
  const [loading, setLoading] = useState(false);


  const inventoryStateInitial = {
    trip_type: "O",
    flight_stops: "",
    airline_id: "",
    flight_number: "",

    departure_airport_id: "",
    departure_airport_name: "",
    departure_airport_code: "",
    departure_airport_city: "",
    departure_time: "",
    departure_terminal: "",

    arrival_airport_id: "",
    arrival_airport_name: "",
    arrival_airport_code: "",
    arrival_airport_city: "",
    arrival_time: "",
    arrival_terminal: "",

    rbd: "",
    baggage_policy: "15",
    fare_rule: "non_refundable_non_changable",
    fare_code: "",
    supplier_type: "self",
    supplier_info: user?.name,
    supplier_id: null,
    hr: ""
  }

  const [inventoryInfo, setInventoryInfo] = useState(inventoryStateInitial);
  const [pnrInfo, setPnrInfo] = useState([]);
  const [flightInfo, setFlightInfo] = useState({
    flightCode: "",
    flightNumber: ""
  })

  const [defaultValueDepAirport, setDefaultValueDepAirport] = useState({
    value: 0,
    label: "Select Departure Airport"
  })

  const [defaultValueArrAirport, setDefaultValueArrAirport] = useState({
    value: 0,
    label: "Select Arrival Airport"
  })


  const [airportData, setAirportData] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  useEffect(() => {
    console.log("date", dateValue.toString());
    loadAirlines();
    loadAirports();

    //creating state for stops
    if (!isNaN(flightStops)) {
      const newStops = Array.from({ length: parseInt(flightStops) }, (_, i) => ({
        departure_airport: null,
        arrival_airport: null,
        stop_number: i + 1,
        departure_time: '',
        arrival_time: '',
        departure_terminal: '',
        arrival_terminal: ''
      }));
      setStopsData(newStops);
    }

    //creating state for pnr details
    if (Array.isArray(dateValue)) {
      let pnrArr = [];
      for (let singleDate of dateValue) {
        const pnrStateInitial = {
          departure_date: singleDate.toString(),
          arrival_date: nextDayArrivalSelectedValue == "0" ? singleDate.toString() : addDay(singleDate.toString(), 1),
          pnr: "",
          seat_quantity: 0,
          infant_amount: 0,
          basic_amount: 0,
          yq_amount: 0,
          yr_amount: 0,
          ot_amount: 0,
          total_amount: 0,
          markup1: 0,
          markup2: 0
        }
        pnrArr.push(pnrStateInitial);
      }
      setPnrInfo(pnrArr);

    }

    const handleResize = () => {
      setMonthsToShow(window.innerWidth < 768 ? 1 : 2);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);

  }, [dateValue, flightStops, nextDayArrivalSelectedValue]);

  const getLastStop = () => {
    if (stopsData?.length > 0) {
      return stopsData[stopsData?.length - 1]?.arrival_airport;
    } else {
      return {
        city_name: inventoryInfo?.arrival_airport_city,
        airport_code: inventoryInfo?.arrival_airport_code,

      }
    }
  }

  const handleStopChange = (index, field, value) => {
    const updatedStops = [...stopsData];
    if (["departure_time", "arrival_time"].includes(field)) {
      value = value.replace(/\D/g, ""); // remove non-digits

      if (value.length > 2) {
        value = value.slice(0, 2) + ":" + value.slice(2, 4); // insert ":"
      }

      if (value.length > 5) {
        value = value.slice(0, 5); // max length 5 (HH:MM)
      }
      console.log("valueee in handleStop change", value);

    }
    updatedStops[index][field] = value;
    setStopsData(updatedStops);
  };

  const handlePnrChange = (index, field, value) => {
    const updatedPnr = [...pnrInfo];
    const amountFields = ['basic_amount', 'yq_amount', 'yr_amount', 'ot_amount'];
    // If any amount field is updated, recalculate total_amount
    if (amountFields.includes(field)) {
      updatedPnr[index][field] = parseFloat(value) || 0;
      const { basic_amount, yq_amount, yr_amount, ot_amount } = updatedPnr[index];

      const total =
        parseFloat(basic_amount) +
        parseFloat(yq_amount) +
        parseFloat(yr_amount) +
        parseFloat(ot_amount);

      updatedPnr[index].total_amount = parseFloat(total.toFixed(2));
    } else {
      updatedPnr[index][field] = value;
    }

    setPnrInfo(updatedPnr);
  };

  const nextDayArrivalHandleChange = (event) => {
    setNextDayArrivalSelectedValue(event.target.value);
  };

  const handleFlightStop = (e) => {
    setFlightStops(e.target.value);
    setInventoryInfo({ ...inventoryInfo, flight_stops: e.target.value });
  }

  const handleFlightInfo = (e) => {
    setFlightInfo({ ...flightInfo, [e.target.name]: e.target.value });
    setInventoryInfo({ ...inventoryInfo, flight_number: e.target.value });
  }

  const handleFlightSelectChange = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFlightInfo({ ...flightInfo, flightCode: selectedOption?.airline_code });
    setInventoryInfo({ ...inventoryInfo, airline_id: selectedOption?.value });
  };

  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }

  const loadAirlines = async () => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/airlines?&page=1&limit=500`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setAirlinesDropdown(apiRes?.resData);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
        //showSwal("Error",apiRes.message,"error")

      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }

  const loadAirports = async (searchq = null) => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/airport?searchq=${searchq}&page=1&limit=20`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setAirportData(apiRes.resData);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }

  const handleSelectChangeDepAirport = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setInventoryInfo({
      ...inventoryInfo,
      departure_airport_id: selectedOption?.id,
      departure_airport_name: selectedOption?.airport_name,
      departure_airport_code: selectedOption?.airport_code,
      departure_airport_city: selectedOption?.city_name,
    })
  };


  const handleSelectChangeArrAirport = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setInventoryInfo({
      ...inventoryInfo,
      arrival_airport_id: selectedOption?.id,
      arrival_airport_name: selectedOption?.airport_name,
      arrival_airport_code: selectedOption?.airport_code,
      arrival_airport_city: selectedOption?.city_name,
    })

  };



  const getFlightInfo = async (e) => {
    //e.preventDefault();
    try {
      let apiUrl = `${BASE_URL}/api/flights?flight_code=${flightInfo?.flightCode}&flight_number=${flightInfo?.flightNumber}`;
      let flightApiRes = await makeApiCall("GET", null, apiUrl);
      console.log(flightApiRes);
      if (flightApiRes.statusCode == 200) {
        if (flightApiRes?.resData?.flights.length > 0) {
          toast.success(flightApiRes.message);
          let flightDataRes = flightApiRes?.resData?.flights[0]
          setDefaultValueDepAirport({
            value: flightDataRes?.departure_airport_id,
            label: flightDataRes?.departure_airport_city_name + ", " + flightDataRes?.departure_airport_name + " (" + flightDataRes?.departure_airport_code + ") "
          });

          setDefaultValueArrAirport({
            value: flightDataRes?.arrival_airport_id,
            label: flightDataRes?.arr_airport_city_name + ", " + flightDataRes?.arrival_airport_name + " (" + flightDataRes?.arrival_airport_code + ") "
          });


          setInventoryInfo({
            ...inventoryInfo,
            airline_id: flightDataRes.airline_id,
            flight_number: flightDataRes.flight_number,

            departure_airport_id: flightDataRes.departure_airport_id,
            departure_airport_name: flightDataRes.departure_airport_name,
            departure_airport_code: flightDataRes.departure_airport_code,
            departure_airport_city: flightDataRes.departure_airport_city_name,
            departure_time: flightDataRes.departure_time,
            departure_terminal: flightDataRes.departure_terminal,

            arrival_airport_id: flightDataRes.arrival_airport_id,
            arrival_airport_name: flightDataRes.arrival_airport_name,
            arrival_airport_code: flightDataRes.arrival_airport_code,
            arrival_airport_city: flightDataRes.arr_airport_city_name,
            arrival_time: flightDataRes.arrival_time,
            arrival_terminal: flightDataRes.arrival_terminal,

          })

        } else {
          toast.error("Flight info not found");
        }

      } else {
        toast.error(flightApiRes.message);
      }
    } catch (err) {
      console.log("Fatal Error", err);
      toast.error("Something Went Wrong...");
    }

  }


  const submitRule = (e) => {
    e.preventDefault();

  }

  const handleSelectChangeSupplier = (selectedOption) => {
    setSelectedSupplier(selectedOption);
    if (selectedOption) {
      console.log("Selected supplier:", selectedOption);
      setInventoryInfo({ ...inventoryInfo, supplier_info: selectedOption?.agency_name, supplier_id: selectedOption?.value })
    } else {
      console.log("Cleared selection");
      setInventoryInfo({ ...inventoryInfo, supplier_info: user?.name, supplier_id: null })
    }
  };


  const handleInventory = (e) => {
    if (e.target.name == "supplier_type") {
      if (e.target.value == "self") {
        setSelectedSupplier(null); // Clear the supplier dropdown selection
        setInventoryInfo({ 
          ...inventoryInfo, 
          [e.target.name]: e.target.value,
          supplier_info: user?.name, 
          supplier_id: userProfile?.id || null 
        });
      } else {
        setInventoryInfo({ 
          ...inventoryInfo, 
          [e.target.name]: e.target.value,
          supplier_info: "", 
          supplier_id: null 
        });
      }
    } else if (["departure_time", "arrival_time"].includes(e.target.name)) {
      let value = e.target.value.replace(/\D/g, ""); // remove non-digits

      if (value.length > 2) {
        value = value.slice(0, 2) + ":" + value.slice(2, 4); // insert ":"
      }

      if (value.length > 5) {
        value = value.slice(0, 5); // max length 5 (HH:MM)
      }
      setInventoryInfo({ ...inventoryInfo, [e.target.name]: value });
    } else {
      setInventoryInfo({ ...inventoryInfo, [e.target.name]: e.target.value });
    }
  }


  const handleInventorySubmit = async (e) => {
    e.preventDefault();
    console.log("handleInventorySubmit");
    let inventoryPayload = {};
    inventoryPayload['flight_stop_count'] = flightStops;
    inventoryPayload['sector_details'] = inventoryInfo;
    inventoryPayload['flight_stops_data'] = stopsData;
    inventoryPayload['pnr_details'] = pnrInfo;
    console.log("inventory form data final submit", inventoryPayload);

    try {
      setLoading(true);
      let bodyPayload = {};

      let apiUrl = `${BASE_URL}/api/inventory`;
      let apiRes = await makeApiCall("POST", inventoryPayload, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
      } else {
        console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
    }

  }

  const loadSuppliers = async (searchq = null) => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/suppliers?page=1&limit=20`;
      let payload = {
        "agency_name": "",
        "head_person": "",
        "mobile": "",
        "email": ""
      }
      let apiRes = await makeApiCall("POST", payload, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        return apiRes.resData.suppliers;
      } else {
        toast.error(apiRes.message);
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }





  if (loading) return (<ContentLoader loaderType="circleSpin" />)

return (
  <>
    {/* Back Button */}
    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
      <Link
        to="/inventory/list"
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          padding: "8px 18px", borderRadius: 8,
          border: "1.5px solid #1a3a8f", color: "#1a3a8f",
          fontWeight: 600, fontSize: 14, textDecoration: "none", background: "#fff"
        }}
      >
        <i className="bi bi-arrow-left" /> Back To Inventory
      </Link>
    </div>

    {/* Flight Configuration */}
    <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e8ecf4", marginBottom: 20, overflow: "hidden" }}>
      <div style={{ padding: "16px 22px", borderBottom: "1px solid #f0f2f8", display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: "#eef0ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <i className="bi bi-signpost-2" style={{ color: "#1a3a8f", fontSize: 16 }} />
        </div>
        <span style={{ fontWeight: 700, fontSize: 15, color: "#0f2557" }}>Flight Configuration</span>
      </div>
      <div style={{ padding: "20px 22px" }}>
        <div className="row g-3">
          <div className="col-md-3">
            <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Trip Type</label>
            <select className="form-select" style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, color: "#374151" }} name="trip_type" onChange={handleInventory}>
              <option value="O">One Way</option>
              <option value="R">Round Trip</option>
            </select>
          </div>
          <div className="col-md-3">
            <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Flight Stops</label>
            <select className="form-select" style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, color: "#374151" }} value={flightStops} onChange={handleFlightStop}>
              <option value={0}>Direct</option>
              <option value={1}>1 Stop</option>
              <option value={2}>2 Stop</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <form onSubmit={handleInventorySubmit}>
      {/* Sector Detail */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e8ecf4", marginBottom: 20, overflow: "hidden" }}>
        <div style={{ padding: "16px 22px", borderBottom: "1px solid #f0f2f8", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "#eef0ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <i className="bi bi-airplane" style={{ color: "#1a3a8f", fontSize: 16 }} />
          </div>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#0f2557" }}>Sector Detail</span>
        </div>
        <div style={{ padding: "20px 22px" }}>
          <div className="row g-3">
            <div className="col-md-6">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Travel Date</label>
              <DatePicker
                multiple
                value={dateValue}
                numberOfMonths={monthsToShow}
                onChange={setDateValue}
                inputClass="custom-input-calendar form-control"
                dateSeparator=" , "
                minDate={today}
              />
            </div>
            <div className="col-md-4">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Airline</label>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <Select
                    options={airlinesDropdown}
                    onChange={handleFlightSelectChange}
                    placeholder="Select airline"
                    isSearchable={true}
                    isClearable={true}
                  />
                </div>
                <div style={{ width: 38, height: 38, borderRadius: 8, border: "1.5px solid #dde3ef", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", background: "#f8f9fe", flexShrink: 0 }}>
                  <img width={22} height={22} src={`https://images.kiwi.com/airlines/32/${flightInfo?.flightCode}.png`} style={{ objectFit: "contain" }} />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Flight Number</label>
              <div style={{ display: "flex", gap: 6 }}>
                <input
                  type="text" className="form-control"
                  style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                  name="flight_number" placeholder="e.g. 101"
                  onChange={handleFlightInfo}
                />
                <button
                  type="button" onClick={getFlightInfo}
                  style={{ flexShrink: 0, width: 38, height: 38, borderRadius: 8, border: "none", background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                  <i className="bi bi-search" style={{ fontSize: 14 }} />
                </button>
              </div>
            </div>
          </div>

          <div className="row g-3" style={{ marginTop: 4 }}>
            <div className="col-md-6">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Departure Airport</label>
              <AsyncSelect
                cacheOptions name="airport_dropdown" placeholder="Search Departure Airport"
                loadOptions={loadAirports} value={defaultValueDepAirport}
                onChange={(val) => { setDefaultValueDepAirport(val); handleSelectChangeDepAirport(val); }}
                defaultOptions={defaultValueDepAirport ? [defaultValueDepAirport, ...airportData] : airportData}
                isClearable isSearchable
              />
            </div>
            <div className="col-md-6">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Arrival Airport</label>
              <AsyncSelect
                cacheOptions name="airport_dropdown" placeholder="Search Arrival Airport"
                loadOptions={loadAirports} value={defaultValueArrAirport}
                onChange={(val) => { setDefaultValueArrAirport(val); handleSelectChangeArrAirport(val); }}
                defaultOptions={defaultValueArrAirport ? [defaultValueArrAirport, ...airportData] : airportData}
                isClearable isSearchable
              />
            </div>
          </div>

          <div className="row g-3" style={{ marginTop: 4 }}>
            <div className="col-md-3">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Departure Time</label>
              <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                <span style={{ padding: "0 10px", color: "#8a9ab5", background: "#f8f9fe", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center" }}>
                  <i className="bi bi-clock" style={{ fontSize: 14 }} />
                </span>
                <input type="text" className="form-control" style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none" }}
                  name="departure_time" placeholder="HH:MM" onChange={handleInventory} value={inventoryInfo?.departure_time}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Arrival Time</label>
              <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                <span style={{ padding: "0 10px", color: "#8a9ab5", background: "#f8f9fe", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center" }}>
                  <i className="bi bi-clock" style={{ fontSize: 14 }} />
                </span>
                <input type="text" className="form-control" style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none" }}
                  name="arrival_time" placeholder="HH:MM" onChange={handleInventory} value={inventoryInfo?.arrival_time}
                />
              </div>
            </div>
            <div className="col-md-2">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Dep. Terminal</label>
              <input type="text" className="form-control"
                style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                name="departure_terminal" placeholder="e.g. T1" onChange={handleInventory} value={inventoryInfo?.departure_terminal}
              />
            </div>
            <div className="col-md-2">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Arr. Terminal</label>
              <input type="text" className="form-control"
                style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                name="arrival_terminal" placeholder="e.g. T2" onChange={handleInventory} value={inventoryInfo?.arrival_terminal}
              />
            </div>
            <div className="col-md-2">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Next Day Arrival</label>
              <select
                className="form-select"
                style={{
                  borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, fontWeight: 700,
                  color: nextDayArrivalSelectedValue === "1" ? "#065f46" : "#dc2626",
                  background: nextDayArrivalSelectedValue === "1" ? "#ecfdf5" : "#fff1f1"
                }}
                value={nextDayArrivalSelectedValue} onChange={nextDayArrivalHandleChange}
              >
                <option value="0">No</option>
                <option value="1">YES</option>
              </select>
            </div>
          </div>

          {/* Dynamic Stops */}
          {Array.from({ length: parseInt(flightStops) }, (_, i) => (
            <div key={i} style={{ marginTop: 20, background: "#f8f9fe", borderRadius: 10, border: "1px solid #eef0f8", padding: "16px 18px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <div style={{ width: 30, height: 30, borderRadius: 8, background: "#fffbeb", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className="bi bi-geo-alt" style={{ color: "#b45309", fontSize: 14 }} />
                </div>
                <span style={{ fontWeight: 700, fontSize: 14, color: "#0f2557" }}>{numberSuffix(i + 1)} Stop</span>
              </div>
              <div className="row g-3">
                <div className="col-md-6">
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Departure Airport</label>
                  <AsyncSelect
                    cacheOptions name="departure_airport" placeholder="Departure Airport"
                    loadOptions={loadAirports} onChange={(val) => handleStopChange(i, 'departure_airport', val)}
                    defaultOptions={airportData} isClearable isSearchable
                  />
                </div>
                <div className="col-md-6">
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Arrival Airport</label>
                  <AsyncSelect
                    cacheOptions name="arrival_airport" placeholder="Arrival Airport"
                    loadOptions={loadAirports} onChange={(val) => handleStopChange(i, 'arrival_airport', val)}
                    defaultOptions={airportData} isClearable isSearchable
                  />
                </div>
              </div>
              <div className="row g-3" style={{ marginTop: 4 }}>
                <div className="col-md-3">
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Departure Time</label>
                  <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                    <span style={{ padding: "0 10px", color: "#8a9ab5", background: "#fff", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center" }}>
                      <i className="bi bi-clock" style={{ fontSize: 13 }} />
                    </span>
                    <input type="text" className="form-control" style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none" }}
                      name="departure_time" placeholder="HH:MM"
                      onChange={(e) => handleStopChange(i, 'departure_time', e.target.value)} value={stopsData[i]?.departure_time}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Arrival Time</label>
                  <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                    <span style={{ padding: "0 10px", color: "#8a9ab5", background: "#fff", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center" }}>
                      <i className="bi bi-clock" style={{ fontSize: 13 }} />
                    </span>
                    <input type="text" className="form-control" style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none" }}
                      name="arrival_time" placeholder="HH:MM"
                      onChange={(e) => handleStopChange(i, 'arrival_time', e.target.value)} value={stopsData[i]?.arrival_time}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Dep. Terminal</label>
                  <input type="text" className="form-control" style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                    name="departure_terminal" placeholder="e.g. T1"
                    onChange={(e) => handleStopChange(i, 'departure_terminal', e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Arr. Terminal</label>
                  <input type="text" className="form-control" style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                    name="arrival_terminal" placeholder="e.g. T2"
                    onChange={(e) => handleStopChange(i, 'arrival_terminal', e.target.value)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Rules Detail */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e8ecf4", marginBottom: 20, overflow: "hidden" }}>
        <div style={{ padding: "16px 22px", borderBottom: "1px solid #f0f2f8", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "#ecfdf5", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <i className="bi bi-shield-check" style={{ color: "#065f46", fontSize: 16 }} />
          </div>
          <span style={{ fontWeight: 700, fontSize: 15, color: "#0f2557" }}>Rules Detail</span>
        </div>
        <div style={{ padding: "20px 22px" }}>
          <div className="row g-3">
            <div className="col-md-3">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>RBD</label>
              <input name="rbd" type="text" className="form-control"
                style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, textTransform: "uppercase" }}
                placeholder="Reservation Booking Designator" maxLength={1} onChange={handleInventory}
              />
            </div>
            <div className="col-md-3">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Baggage Policy (kg)</label>
              <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                <span style={{ padding: "0 10px", color: "#8a9ab5", background: "#f8f9fe", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center" }}>
                  <i className="bi bi-briefcase" style={{ fontSize: 14 }} />
                </span>
                <input name="baggage_policy" type="text" className="form-control"
                  style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none" }}
                  placeholder="kg" value={inventoryInfo?.baggage_policy} onChange={handleInventory}
                />
              </div>
            </div>
            <div className="col-md-4">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Fare Rule</label>
              <select name="fare_rule" className="form-select"
                style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, color: "#374151" }}
                onChange={handleInventory}
              >
                <option value="non_refundable_non_changable">Non Refundable, Non Changable</option>
              </select>
            </div>
            <div className="col-md-2">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Fare Code</label>
              <input name="fare_code" type="text" className="form-control"
                style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, textTransform: "uppercase" }}
                placeholder="e.g. ECO" maxLength={3} onChange={handleInventory}
              />
            </div>
          </div>
          <div className="row g-3" style={{ marginTop: 4 }}>
            <div className="col-md-3">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Supplier Type</label>
              <select name="supplier_type" className="form-select"
                style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, color: "#374151" }}
                value={inventoryInfo?.supplier_type} onChange={handleInventory}
              >
                <option value="">Select</option>
                <option value="self">Self</option>
                <option value="other">Other</option>
              </select>
            </div>
            {inventoryInfo?.supplier_type === "other" && (
              <div className="col-md-3">
                <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Supplier</label>
                <AsyncSelect
                  cacheOptions name="supplier_dropdown" placeholder="Select Supplier"
                  loadOptions={loadSuppliers} value={selectedSupplier}
                  onChange={handleSelectChangeSupplier} defaultOptions={true}
                  isClearable isSearchable
                />
              </div>
            )}
            <div className="col-md-3">
              <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Hide Inventory Before (Hr)</label>
              <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                <span style={{ padding: "0 10px", color: "#8a9ab5", background: "#f8f9fe", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center" }}>
                  <i className="bi bi-eye-slash" style={{ fontSize: 14 }} />
                </span>
                <input name="hr" type="text" className="form-control"
                  style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none", textTransform: "uppercase" }}
                  placeholder="Hours" maxLength={3} onChange={handleInventory}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PNR Details */}
      {dateValue && dateValue.length >= 1 && (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e8ecf4", marginBottom: 20, overflow: "hidden" }}>
          <div style={{ padding: "16px 22px", borderBottom: "1px solid #f0f2f8", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: "#eef0ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className="bi bi-ticket-perforated" style={{ color: "#1a3a8f", fontSize: 16 }} />
              </div>
              <span style={{ fontWeight: 700, fontSize: 15, color: "#0f2557" }}>PNR Details</span>
            </div>
            {inventoryInfo?.departure_airport_city && (
              <span style={{ fontSize: 13, color: "#8a9ab5", fontWeight: 600 }}>
                <span style={{ padding: "3px 8px", borderRadius: 6, background: "#eef0ff", color: "#1a3a8f", fontWeight: 700, fontSize: 12 }}>{inventoryInfo?.departure_airport_code}</span>
                <span style={{ margin: "0 6px", color: "#8a9ab5" }}>→</span>
                <span style={{ padding: "3px 8px", borderRadius: 6, background: "#eef0ff", color: "#1a3a8f", fontWeight: 700, fontSize: 12 }}>{getLastStop()?.airport_code}</span>
              </span>
            )}
          </div>
          <div style={{ padding: "20px 22px" }}>
            {dateValue.map((singleDate, i) => (
              <div key={i} style={{ background: "#f8f9fe", borderRadius: 10, border: "1px solid #eef0f8", padding: "16px 18px", marginBottom: i < dateValue.length - 1 ? 16 : 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 7, background: "#eef0ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <i className="bi bi-calendar3" style={{ color: "#1a3a8f", fontSize: 13 }} />
                  </div>
                  <span style={{ fontWeight: 700, fontSize: 13, color: "#0f2557" }}>{singleDate.toString()}</span>
                  {nextDayArrivalSelectedValue === "1" && (
                    <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, background: "#fffbeb", color: "#b45309", fontWeight: 700, marginLeft: 4 }}>
                      +1 Day Arrival
                    </span>
                  )}
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Departure Date</label>
                    <input type="text" className="form-control"
                      style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 13, color: "#8a9ab5", background: "#f0f2f8" }}
                      value={singleDate.toString()} readOnly
                    />
                  </div>
                  <div className="col-md-3">
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Arrival Date</label>
                    <input type="text" className="form-control"
                      style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 13, color: "#8a9ab5", background: "#f0f2f8" }}
                      value={nextDayArrivalSelectedValue === "0" ? singleDate.toString() : addDay(singleDate.toString(), 1)} readOnly
                    />
                  </div>
                  <div className="col-md-2">
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>PNR</label>
                    <input type="text" className="form-control"
                      style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14, fontFamily: "monospace" }}
                      placeholder="e.g. ABC123" name="pnr"
                      onChange={(e) => handlePnrChange(i, 'pnr', e.target.value)}
                    />
                  </div>
                  <div className="col-md-2">
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Seat Quantity</label>
                    <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                      <span style={{ padding: "0 10px", color: "#8a9ab5", background: "#fff", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center" }}>
                        <i className="bi bi-people" style={{ fontSize: 13 }} />
                      </span>
                      <input type="number" className="form-control"
                        style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none" }}
                        name="seat_quantity" onChange={(e) => handlePnrChange(i, 'seat_quantity', e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Infant Amount</label>
                    <input type="number" step="0.01" className="form-control"
                      style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                      name="infant_amount"
                      onChange={(e) => handlePnrChange(i, 'infant_amount', e.target.value)}
                      value={pnrInfo[i]?.['infant_amount'] || 0}
                    />
                  </div>
                </div>

                {/* Fare Breakdown */}
                <div style={{ marginTop: 14, background: "#fff", borderRadius: 8, border: "1px solid #eef0f8", padding: "14px 16px" }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 12 }}>Fare Breakdown</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Basic Amount</label>
                      <input type="number" step="0.01" className="form-control"
                        style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                        name="basic_amount" onChange={(e) => handlePnrChange(i, 'basic_amount', e.target.value)} value={pnrInfo[i]?.['basic_amount']}
                      />
                    </div>
                    <div className="col-md-3">
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>YQ Amount</label>
                      <input type="number" className="form-control"
                        style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                        name="yq_amount" onChange={(e) => handlePnrChange(i, 'yq_amount', e.target.value)} value={pnrInfo[i]?.['yq_amount']}
                      />
                    </div>
                    <div className="col-md-3">
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>YR Amount</label>
                      <input type="number" step="0.01" className="form-control"
                        style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                        name="yr_amount" onChange={(e) => handlePnrChange(i, 'yr_amount', e.target.value)} value={pnrInfo[i]?.['yr_amount']}
                      />
                    </div>
                    <div className="col-md-3">
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>OT Amount</label>
                      <input type="number" step="0.01" className="form-control"
                        style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                        name="ot_amount" onChange={(e) => handlePnrChange(i, 'ot_amount', e.target.value)} value={pnrInfo[i]?.['ot_amount']}
                      />
                    </div>
                  </div>
                  <div className="row g-3" style={{ marginTop: 8 }}>
                    <div className="col-md-4">
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Total Amount</label>
                      <div style={{ display: "flex", alignItems: "center", border: "1.5px solid #dde3ef", borderRadius: 8, overflow: "hidden" }}>
                        <span style={{ padding: "0 10px", color: "#065f46", background: "#ecfdf5", borderRight: "1px solid #dde3ef", height: 38, display: "flex", alignItems: "center", fontWeight: 700, fontSize: 13 }}>₹</span>
                        <input type="number" className="form-control"
                          style={{ border: "none", borderRadius: 0, fontSize: 14, boxShadow: "none", fontWeight: 700, color: "#065f46", background: "#f8fffe" }}
                          name="total_amount"
                          onChange={(e) => handlePnrChange(i, 'total_amount', e.target.value)}
                          value={pnrInfo[i]?.['total_amount'] || 0}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Markup 1</label>
                      <input type="number" step="0.01" className="form-control"
                        style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                        name="markup1" onChange={(e) => handlePnrChange(i, 'markup1', e.target.value)} value={pnrInfo[i]?.['markup1']}
                      />
                    </div>
                    <div className="col-md-4">
                      <label style={{ fontSize: 11, fontWeight: 700, color: "#8a9ab5", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6, display: "block" }}>Markup 2</label>
                      <input type="number" step="0.01" className="form-control"
                        style={{ borderRadius: 8, border: "1.5px solid #dde3ef", fontSize: 14 }}
                        name="markup2" onChange={(e) => handlePnrChange(i, 'markup2', e.target.value)} value={pnrInfo[i]?.['markup2']}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
              <button type="submit" style={{
                padding: "10px 28px", borderRadius: 8, border: "none",
                background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                color: "#fff", fontWeight: 700, fontSize: 14,
                display: "flex", alignItems: "center", gap: 8,
                boxShadow: "0 4px 12px rgba(15,37,87,0.3)"
              }}>
                <i className="bi bi-floppy" /> Submit Inventory
              </button>
            </div>
          </div>
        </div>
      )}
    </form>
  </>
)
}

export default AddInventory